import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import CheckboxIcon from '../../../../../../../../../components/icons/CheckboxIcon';
import Button from '../../../../../../../../../components/global/Button';
import ShoppingBasketIcon from '../../../../../../../../../components/icons/ShoppingBasketIcon';

const propTypes = {
  photosAdded: PropTypes.number,
  onClose: PropTypes.func,
  onCheckout: PropTypes.func,
};

const DigitalBundleConfigurationComplete = ({
  photosAdded,
  onClose,
  onCheckout,
}) => {
  const cart = useSelector(({ checkout }) => checkout.cart);
  const hasCheckoutAction = cart.length > 0 && onCheckout;

  return (
    <div>
      <div className="d-flex align-items-center mb-2">
        <h3 className="w-100 text-center mb-0">
          Your selected {pluralize('photo', photosAdded)} can now be downloaded!
        </h3>
      </div>

      <div className="d-flex align-items-center mb-2">
        {hasCheckoutAction && (
          <span>
            <CheckboxIcon size={24} />
          </span>
        )}
        <p
          className={classNames({
            'mb-0': true,
            'ml-1': hasCheckoutAction,
            'd-none': !hasCheckoutAction,
          })}
        >
          Remember to go through checkout below to finalize your prints order.
        </p>
      </div>

      {hasCheckoutAction && (
        <Button
          btnStyle="success-vibrant"
          btnBlock
          onClick={() => {
            onCheckout();
            onClose();
          }}
          className="btn-checkout-print-product-size-success mb-2"
        >
          <ShoppingBasketIcon /> Checkout now
        </Button>
      )}
      <Button btnOutline btnBlock onClick={onClose}>
        Return to Photos
      </Button>
    </div>
  );
};

DigitalBundleConfigurationComplete.propTypes = propTypes;

export default DigitalBundleConfigurationComplete;
